import { render, staticRenderFns } from "./FocusChart.vue?vue&type=template&id=3b86e4d5&"
import script from "./FocusChart.vue?vue&type=script&lang=js&"
export * from "./FocusChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports